import Animation from "@/Shared/Animations/Animation";
import { IconsProgressSpinnerFrame } from "./CustomComponents/IconsProgressSpinnerFrame";
import { ProgressSpinnerSizes } from "./ProgressSpinnerSizes";

interface ProgressSpinerProps {
  size: ProgressSpinnerSizes;
}

function ProgressSpinner(props: ProgressSpinerProps) {
  return (
    <IconsProgressSpinnerFrame size={props.size}>
      <Animation
        pathToAnimation="/animations/progress-animation.json"
        lottieFilesUrl="https://lottiefiles.com/8311-loading"
        loop={true}
      />
    </IconsProgressSpinnerFrame>
  );
}

export default ProgressSpinner;
